<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="none">
    <path
      d="m594.43-296.48-387.6-387.61q-14.96-14.95-14.46-34.54t15.46-34.54q14.95-14.96 34.54-14.96t34.54 14.96l386.61 387.6v-170q0-20.35 14.25-34.63 14.24-14.28 34.54-14.28 20.3 0 34.76 14.3 14.45 14.3 14.45 34.67v287.75q0 20.37-14.29 34.83-14.3 14.45-34.68 14.45H424.81q-20.38 0-34.83-14.24-14.46-14.25-14.46-34.55 0-20.3 14.28-34.75 14.28-14.46 34.63-14.46h170Z"
      :fill="fill"
    />
  </svg>
</template>
<script>
export default {
  props: {
    fill: {
      type: String
    }
  }
}
</script>
